import { defineMessages } from 'react-intl';

export const webinarFormMessages = defineMessages({
	initializing: {
		id: 'uniform.webinarForm.initializing',
		defaultMessage: 'Loading registration form…',
	},
	configurationError: {
		id: 'uniform.webinarForm.configurationError',
		defaultMessage: 'This webinar registration form is not configured correctly.',
	},
	sessionDateConfigurationError: {
		id: 'uniform.webinarForm.sessionDateConfigurationError',
		defaultMessage: 'Each webinar session needs either a structured Date or a Date Label.',
	},
	registerHeading: {
		id: 'uniform.webinarForm.registerHeading',
		defaultMessage: 'Register now:',
	},
	onDemandHeading: {
		id: 'uniform.webinarForm.onDemandHeading',
		defaultMessage: 'Watch on-demand:',
	},
	sessionLegend: {
		id: 'uniform.webinarForm.sessionLegend',
		defaultMessage: 'Select a date and time',
	},
	firstName: {
		id: 'uniform.webinarForm.field.firstName',
		defaultMessage: 'First name',
	},
	lastName: {
		id: 'uniform.webinarForm.field.lastName',
		defaultMessage: 'Last name',
	},
	company: {
		id: 'uniform.webinarForm.field.company',
		defaultMessage: 'Company name',
	},
	department: {
		id: 'uniform.webinarForm.field.department',
		defaultMessage: 'Department',
	},
	jobTitle: {
		id: 'uniform.webinarForm.field.jobTitle',
		defaultMessage: 'Job title',
	},
	email: {
		id: 'uniform.webinarForm.field.email',
		defaultMessage: 'Work email',
	},
	phone: {
		id: 'uniform.webinarForm.field.phone',
		defaultMessage: 'Phone number',
	},
	companySize: {
		id: 'uniform.webinarForm.field.companySize',
		defaultMessage: 'Company size',
	},
	country: {
		id: 'uniform.webinarForm.field.country',
		defaultMessage: 'Country',
	},
	selectOption: {
		id: 'uniform.webinarForm.field.selectOption',
		defaultMessage: 'Select an option',
	},
	alternateEmail: {
		id: 'uniform.webinarForm.field.alternateEmail',
		defaultMessage: 'Alternate email',
	},
	required: {
		id: 'uniform.webinarForm.validation.required',
		defaultMessage: 'This field is required.',
	},
	invalidEmail: {
		id: 'uniform.webinarForm.validation.invalidEmail',
		defaultMessage: 'Enter a valid email address.',
	},
	businessEmail: {
		id: 'uniform.webinarForm.validation.businessEmail',
		defaultMessage:
			'Enter your business email address. This form does not accept addresses from {domain}.',
	},
	privacyDisclosure: {
		id: 'uniform.webinarForm.privacyDisclosure',
		defaultMessage: 'By submitting this form, I acknowledge receipt of Atlassian’s',
	},
	privacyPolicy: {
		id: 'uniform.webinarForm.privacyPolicy',
		defaultMessage: 'Privacy Policy',
	},
	marketingOptIn: {
		id: 'uniform.webinarForm.marketingOptIn',
		defaultMessage:
			'Yes! I would like to receive promotional emails including product news, events and more from Atlassian and its affiliates.',
	},
	registerButton: {
		id: 'uniform.webinarForm.registerButton',
		defaultMessage: 'Register now',
	},
	watchButton: {
		id: 'uniform.webinarForm.watchButton',
		defaultMessage: 'Watch now',
	},
	submitError: {
		id: 'uniform.webinarForm.submitError',
		defaultMessage: 'We could not complete your registration. Please try again.',
	},
});
